<script lang="ts">
	import { run } from 'svelte/legacy';

	import type { ReturnedPTImageItem } from '$utils/sanityClient.server';

	import type { CustomBlockComponentProps } from '@portabletext/svelte';

	interface Props {
		portableText: CustomBlockComponentProps<ReturnedPTImageItem>;
	}

	let { portableText }: Props = $props();

	let imageData = $derived(portableText.value);
	// eslint-disable-next-line @typescript-eslint/no-deprecated
	run(() => {
		console.log(imageData);
	});
</script>

<img
	class="mx-auto max-w-full"
	src={imageData.src}
	srcset={imageData.srcset}
	sizes={imageData.sizes}
	alt={imageData.metadata?.altText}
	width={imageData.metadata?.width}
	height={imageData.metadata?.height}
	loading="lazy"
/>
